import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=9d323d10&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=9d323d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d323d10",
  null
  
)

export default component.exports